__turbopack_context__.v({
  "mobileHidden": "QXpeUG_mobileHidden",
  "wavyHover": "QXpeUG_wavyHover",
});
